<template>
  <div class="kkv" style="height: 0px;">
    <el-form class="form" label-width="auto">
      <el-form-item>
        <el-text style="margin-right: 20px; font-size: larger; font-weight: bolder;">
          客户设置
        </el-text>
        <el-button-group>
          <el-button type="primary" @click="save()" :loading="loading.save">保存</el-button>
        </el-button-group>
      </el-form-item>
      <el-form-item label="同时登录数">
        <el-input-number v-model="data.kkv.value" :min="1" :max="100" />
      </el-form-item>
    </el-form>
    <div style="height: 10px;"></div>
  </div>
</template>

<script setup>
import { reactive, } from 'vue'
import { useRouter } from 'vue-router'
import { ElMessage } from 'element-plus'
import api from '../../apis/api'
import cache from '../../utils/cache'
import util from '../../utils/util'
import Editor from '../../components/Editor.vue'

const router = useRouter()
const loading = reactive({
  save: false,
})
const data = reactive({
  kkv: {
    scene: 'ATQ',
    kkey: '',
    value: null,
  },
})

const getKkv = () => {
  loading.save = true
  api.get('/backend/kkv/getList', { params: { scene: 'ATQ' } }).then((res) => {
    if (res.list.length > 0) {
      for (const item of res.list) {
        if (item.kkey == '') {
          data.kkv = item
        }
      }
    }
    loading.save = false
  })
}
getKkv()

const save = () => {
  if (!data.kkv.value) {
    ElMessage.error('请输入同时登录数')
    return
  }
  loading.save = true
  const kkv = {
    scene: data.kkv.scene,
    kkey: data.kkv.kkey,
    value: data.kkv.value + ''
  }
  api.post('/backend/kkv/put', kkv).then(() => {
    ElMessage.success('保存成功')
    getKkv()
  }).finally(() => {
    loading.save = false
  })
}
</script>

<style lang="less">
.kkv {
  margin: auto;
  max-width: 900px;

  .avatar-uploaded {
    width: 178px;
    height: 178px;
    border: 1px dashed var(--el-border-color);
    border-radius: 6px;
    margin-right: 20px;
  }

  .avatar-uploader .el-upload {
    border: 1px dashed var(--el-border-color);
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    transition: var(--el-transition-duration-fast);
  }

  .avatar-uploader .el-upload:hover {
    border-color: var(--el-color-primary);
  }

  .el-icon.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    text-align: center;
  }
}
</style>